module.exports = __webpack_public_path__ + "img/icon-search-input.2f27994f.png";